import { render, staticRenderFns } from "./LinkBack.vue?vue&type=template&id=518036d8"
import script from "./LinkBack.vue?vue&type=script&lang=js"
export * from "./LinkBack.vue?vue&type=script&lang=js"
import style0 from "./LinkBack.vue?vue&type=style&index=0&id=518036d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports